import classNames from 'classnames';
import React from 'react';
import styles from './TextParagraph.module.scss';

const TextParagraph = ({ children, variant, element, ...props }) => {
  // If there's no tag name supplied, use a paragraph element.
  const TagName = element || ('p' as React.ElementType<any>);
  return (
    <TagName
      {...props}
      className={classNames(
        props.className,
        styles.root,
        styles[`is-variant-${variant || 'default'}`],
      )}>
      {children}
    </TagName>
  );
};

export default TextParagraph;
